export default (id, callback, errorCallback) => {
  const options = {
    types: ['geocode'],
    componentRestrictions: { country: 'fr' },
    fields: ['address_components'],
  };
  // eslint-disable-next-line no-undef
  const autocomplete = new google.maps.places.Autocomplete(
    document.getElementById(id),
    options,
  );
  autocomplete.setFields(['address_component']);
  autocomplete.addListener('place_changed',
    () => {
      const results = autocomplete.getPlace().address_components;
      if (results) {
        const format = {
          country: { type: 'long_name', value: '' },
          locality: { type: 'long_name', value: '' },
          postal_code: { type: 'short_name', value: '' },
          street_number: { type: 'short_name', value: '' },
          route: { type: 'long_name', value: '' },
        };
        for (let i = 0; i < results.length; i += 1) {
          const addressType = results[i].types[0];
          if (format[addressType]) {
            const val = results[i][format[addressType].type];
            format[addressType].value = val;
          }
        }
        // eslint-disable-next-line no-inner-declarations
        function objectMap(object, mapFn) {
          const preFormat = Object.keys(object).reduce((result, key) => {
            // eslint-disable-next-line no-param-reassign
            result[key] = mapFn(object[key]);
            return result;
          }, {});
          return {
            street: `${preFormat.street_number} ${preFormat.route}`,
            postalCode: preFormat.postal_code,
            city: preFormat.locality,
            country: preFormat.country,
          };
        }
        callback(objectMap(format, (elem) => elem.value));
      } else { errorCallback(); }
    });
};
